import apiClient from './apiClient'

export const sendOrder = async (order) => {
  return apiClient.post('/v1/sales-order', order)
}
